import React from "react";

// 2023 Live Account Performance — two Flourish charts side by side
// Available chart IDs from eazybot.info/performance:
// 11292463, 11277443, 12323727, 13910791, 12672384, 12525317, 12675780
const CHART_LEFT_ID = "12672384"; // NEW EazyBot Profit Performance (USDT, 2023)
const CHART_RIGHT_ID = "12525317"; // NEW EazyBot Percentage Performance (%, 2023)
const TRADES_COUNTER_ID = "12675780"; // Total Trades Closed On NEW Account 01.Jan.23

const ChartFrame = ({ id, label, testid }) => (
  <iframe
    src={`https://flo.uri.sh/visualisation/${id}/embed`}
    title={label}
    loading="lazy"
    allow="fullscreen"
    style={{ width: "100%", height: "100%", border: 0, display: "block" }}
    data-testid={testid}
  />
);

export const ProvenPerformance = () => {
  return (
    <section
      id="performance"
      data-testid="performance-section"
      className="relative py-14 md:py-16 border-t border-white/10"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-3">
            <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
            <span
              className="font-mono-label section-eyebrow home-eyebrow"
              style={{ color: "#E8C97A", letterSpacing: "0.12em" }}
            >
              Proven Performance
            </span>
            <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
          </div>
          <h2
            className="font-display mt-3 leading-[1.05]"
            style={{ fontSize: "clamp(1.75rem, 3vw, 2.5rem)" }}
            data-testid="performance-heading"
          >
            100% Principal Increase in 18 Months
          </h2>
          <p className="mt-4 font-display text-base md:text-lg italic" style={{ color: "#E8C97A", letterSpacing: "0.025em" }} data-testid="performance-expectations">
            Realistic Expectations, NOT Impossible Promises!
          </p>
          <p className="mx-auto mt-3 max-w-3xl text-sm md:text-base leading-relaxed text-white/70" data-testid="performance-intro">
            EazyBot has years of documented performance data that proves its consistent profitability. These charts are an example of one corporate account, click the link below them to see more results.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-stretch">
          {/* Left chart */}
          <div className="lg:col-span-4 flex flex-col" data-testid="perf-left-wrap">
            <p className="mb-3 text-center font-mono-label text-[10px] text-white/55">
              Profit · Per Coin · USDT
            </p>
            <div className="flex-1 rounded-lg overflow-hidden card-dark" style={{ minHeight: "420px" }}>
              <ChartFrame
                id={CHART_LEFT_ID}
                label="EazyBot Live Account Performance — USDT"
                testid="perf-chart-left"
              />
            </div>
          </div>

          {/* Middle info block */}
          <div
            className="lg:col-span-4 rounded-2xl p-6 md:p-8 text-center"
            style={{
              background:
                "linear-gradient(180deg, rgba(3,172,239,0.08) 0%, rgba(3,172,239,0.04) 100%)",
              border: "1px solid rgba(3,172,239,0.25)",
            }}
            data-testid="perf-info-block"
          >
            <p
              className="font-mono-label text-[11px]"
              style={{ color: "#03ACEF", letterSpacing: "0.35em" }}
            >
              2023 New
            </p>
            <h3
              className="font-display mt-2 leading-[1]"
              style={{
                fontSize: "clamp(1.5rem, 2.4vw, 2.1rem)",
                color: "#03ACEF",
              }}
            >
              Live Account Performance
            </h3>

            <div
              className="mt-7 pt-6 border-t border-white/10"
              data-testid="perf-trades-closed"
            >
              <p
                className="font-mono-label text-[10px]"
                style={{ color: "#03ACEF" }}
              >
                Total Trades Closed
              </p>
              <div
                className="mt-3 rounded-md overflow-hidden border border-white/10 bg-white"
                style={{ height: 110 }}
              >
                <iframe
                  src={`https://flo.uri.sh/visualisation/${TRADES_COUNTER_ID}/embed`}
                  title="Total Trades Closed — Live Counter"
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: 0,
                    display: "block",
                  }}
                  data-testid="perf-trades-counter"
                />
              </div>
            </div>

            <div className="mt-7 space-y-4 text-white/85 text-sm md:text-base leading-relaxed">
              <p>
                The account began trading with{" "}
                <span style={{ color: "#03ACEF" }} className="font-semibold">
                  500 USDT Per Coin
                </span>{" "}
                on{" "}
                <span style={{ color: "#03ACEF" }} className="font-semibold">
                  January 1st, 2023
                </span>{" "}
                with the MAS Default Strategy.
              </p>
              <p
                className="font-display"
                style={{ color: "#03ACEF", fontSize: "1.1rem" }}
              >
                Total Capital = 14,500 USDT
              </p>
            </div>

            <p className="mt-6 pt-5 border-t border-white/10 text-[11px] text-white/55 italic">
              Past results are not a guarantee of future performance.
              <br />
              Note: this account is not paying SSF.
            </p>
          </div>

          {/* Right chart */}
          <div className="lg:col-span-4 flex flex-col" data-testid="perf-right-wrap">
            <p className="mb-3 text-center font-mono-label text-[10px] text-white/55">
              Profit · Per Coin · %
            </p>
            <div className="flex-1 rounded-lg overflow-hidden card-dark" style={{ minHeight: "420px" }}>
              <ChartFrame
                id={CHART_RIGHT_ID}
                label="EazyBot Live Account Performance — Percentage"
                testid="perf-chart-right"
              />
            </div>
          </div>
        </div>

        <div className="mt-10 text-center">
          <a
            href="http://eazybot.info/performance"
            target="_blank"
            rel="noopener noreferrer"
            className="performance-insights-link inline-flex max-w-full items-center justify-center whitespace-normal text-center text-base md:text-lg font-bold"
            style={{ color: "#03ACEF" }}
            data-testid="performance-insights-link"
          >
            VIEW MORE PERFORMANCE RESULTS
          </a>
          <p className="mt-4 text-[11px] text-white/45 font-mono-label" data-testid="performance-disclaimer">
            Source · EazyBot.info
          </p>
        </div>
      </div>
    </section>
  );
};
